import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';


import './style.css'
import { selectLifeOption, selectPropertyOption } from '../precalc/precalcSlice';
import { selectEmail } from '../calc/calcSlice';



export function Pay() {
    let { n1 } = useParams();
    let { n2 } = useParams();
    let { s1 } = useParams();
    let { s2 } = useParams();

    const lifeOption = useSelector(selectLifeOption)
    const propertyOption = useSelector(selectPropertyOption)
    const email = useSelector(selectEmail)

    useEffect(() => {
        setTimeout( () => document.forms['pay'].submit(), 1 )
    }, []);

    return (
        <div className='container-pay'>
            <form id='pay' method='POST' action='https://domstraxovanie.server.paykeeper.ru/create/' >
                <label className='f-raleway-x-mini-g'>Сумма оплаты:</label>
                <input className="form-control f-raleway-15 mt-3" type='text' name='sum' value={ Math.round(parseFloat(s1)*100)/100 + Math.round(parseFloat(s2)*100)/100 } onChange={()=>{}} /> <br />
                <label className='f-raleway-x-mini-g mt-4'>Номер заказа:</label>
                <input className="form-control f-raleway-15 mt-3" type='text' name='orderid' value={`${n1}D${n2}`} onChange={()=>{}}/> <br />
                <label className='f-raleway-x-mini-g mt-4'>Название услуги: </label> Страхование ипотеки 
                <input className="form-control f-raleway-15 mt-3" type='text' name='service_name' value={(propertyOption ? 'Имущество ': '') + (lifeOption ? 'Жизнь': '')} onChange={()=>{}}/> <br />
                <br />
                <input className="form-control f-raleway-15 mt-3" type='text' name='client_email' value={email} onChange={()=>{}}/> <br />
                <br />
                <input className='btn btn-outline-primary mt-3' type='submit' value='Перейти к оплате' onChange={()=>{}}/>
                <input type='hidden' name='cart' 
                    value={
                        `
                            [
                                {
                                    "name":"Страховая премия за полис № 001-062F-0162826 (Имущество).",
                                    "price":${ Math.round( parseFloat(s1)*100 )/100 },
                                    "quantity":1,
                                    "sum":${ Math.round( parseFloat(s1)*100 )/100 },
                                    "tax":"none",
                                    "item_type":"work",
                                    "payment_type":"prepay"
                                    
                                }
                                ,
                                {
                                    "name":"Страховая премия за полис № 001-062F-0162826 (Имущество).",
                                    "price":${Math.round(parseFloat(s2)*100)/100},
                                    "quantity":1,
                                    "sum":${Math.round(parseFloat(s2)*100)/100},
                                    "tax":"none",
                                    "item_type":"work",
                                    "payment_type":"prepay"
                                }                               

                            ]
                        `
                    }
                />
            </form>
        </div>
    )
}